import React, { useEffect } from "react";
import { useHistory } from "react-router-dom"

// reactstrap components
import {
  Card,
  CardBody,
  Row,
  Col,
  CustomInput,
} from "reactstrap";

import {
  Box,
  Button,
  TableContainer,
} from "@mui/material"

import SweetAlert from "react-bootstrap-sweetalert";
import { ToastContainer } from "react-toastify";
import notification from "assets/ringtone.ogg";

import TimerRow from "components/TimerTable/TimerRow"
import TimerTable from "components/TimerTable/TimerTable"
import LanguageDependentText from "components/TimerTable/LanguageDependentText";
import { useHuntTrackerContext } from "tracker-context";

import { SocketIO } from "sessions/socket"
import { HuntTimers } from "sessions/databaseStorage"
import { SessionConfigs } from "sessions/sessionState";
import { dataCenters } from "sessions/resources/datacenters";
import { getDataCenterName } from "sessions/gameInfo";

const Timer = ({match}) => {
  const history = useHistory();
  const [alert, setAlert] = React.useState(null);
  const audioRef = React.createRef();
  const [sHuntInfo, setSHuntInfo] = React.useState([]);
  const [aHuntInfo, setAHuntInfo] = React.useState([]);

  const [loadingState, setLoadingState] = React.useState(true);
  
  const socket = SocketIO.getSocket();

  const dataCenterTravel = async () => {
    return SessionConfigs.setDataCenter("All");
  }

  React.useEffect(() => {
    dataCenterTravel().then(() => {
      if (SessionConfigs.getDataCenter() == "") {
        history.push("/index", {replace: true});
        return () => {};
      };

      SessionConfigs.queryData("/api/lastDeathTimers", {
        "QueryDeathTimers": SessionConfigs.getWorldsOfDataCenter()["Names"],
        "DataCenter": "All"
      }).then((response) => {
        if (response.status == 200) {
          HuntTimers.setTimers(response.data);
          setSHuntInfo(HuntTimers.getSRankInfo());
          setAHuntInfo(HuntTimers.getARankInfo());
        }
        setLoadingState(false);
      }).catch((error) => {
        SessionConfigs.displayError(error, setAlert);
        setLoadingState(false);
      });
    })
  }, []);

  React.useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = SessionConfigs.getAudioVolume();
    }
  }, [audioRef.current]);

  const hideDeadRef = React.useRef();
  React.useEffect(() => {
    if (document.getElementById("srankHideDead") && sHuntInfo.length > 0) document.getElementById("srankHideDead").checked = sHuntInfo[0].hideDead;
    if (document.getElementById("arankHideDead") && aHuntInfo.length > 0) document.getElementById("arankHideDead").checked = aHuntInfo[0].hideDead;
  }, [hideDeadRef.current])

  var timerConfigs = SessionConfigs.getToggleStates();
  const worlds = SessionConfigs.getWorldsOfDataCenter() ? SessionConfigs.getWorldsOfDataCenter()["Names"] : [];
  let dcs = [];
  for (let i in worlds) {
    if (!dcs.includes(getDataCenterName(worlds[i]))) {
      dcs.push(getDataCenterName(worlds[i]));
    }
  }

  const patches = Object.keys(timerConfigs.srankConfig.patch);
  var lastClick = new Date().getTime();
  var lastClickType = "";

  const updateDisplayStatus = (type, calculate) => {
    if (type == "srank") {
      var huntInfo = HuntTimers.getSRankInfo();
    } else if (type == "arank") {
      var huntInfo = HuntTimers.getARankInfo();
    }

    const currentTime = new Date().getTime();
    var huntCount = 0;

    for (var i = 0; i < huntInfo.length; i++) {
      const row = document.getElementById(huntInfo[i].worldName + "_" + huntInfo[i].huntName + "_Row");

      if (!calculate) {
        if ((huntInfo[i].displayState && (!huntInfo[i].hideDead || currentTime > huntInfo[i].expectMinTime )) == row.classList.contains("d-none")) {
          row.classList.toggle("d-none");
        }
      } else {
        if (!row.classList.contains("d-none")) {
          if (currentTime > huntInfo[i].expectMinTime) {
            huntCount+=1;
          }
        }
      }
    }
    return huntCount;
  }

  const toggleWorldState = (type, world, event) => {
    var newClick = new Date().getTime();

    if (newClick - lastClick < 300 && lastClickType == world) {
      lastClick = newClick;

      for (var i = 0; i < worlds.length; i++) {
        if (worlds[i] != world) {
          document.getElementById(type+worlds[i]).classList.remove("btn-selected");
        } else {
          document.getElementById(type+worlds[i]).classList.add("btn-selected");
        }
      }
      SessionConfigs.setWorldSelectOnly(type, world);
      HuntTimers.updateDisplayState(type);
      updateDisplayStatus(type);

    } else {
      lastClick = newClick;
      lastClickType = world;

      event.currentTarget.classList.toggle("btn-selected");
      const state = event.currentTarget.classList.contains("btn-selected");
      SessionConfigs.setWorldSelect(type, world, state);
      HuntTimers.updateDisplayState(type);
      updateDisplayStatus(type);
    }
  }
  
  const togglePatchState = (type, patch, event) => {
    var newClick = new Date().getTime();
    if (newClick - lastClick < 300 && lastClickType == patch) {
      lastClick = newClick;
      
      for (var i = 0; i < patches.length; i++) {
        if (patches[i] != patch) {
          document.getElementById(type+patches[i]).classList.remove("btn-selected");
        } else {
          document.getElementById(type+patches[i]).classList.add("btn-selected");
        }
      }
      SessionConfigs.setPatchSelectOnly(type, patch);
      HuntTimers.updateDisplayState(type);
      updateDisplayStatus(type);

    } else {
      lastClick = newClick;
      lastClickType = patch;

      event.currentTarget.classList.toggle("btn-selected");
      const state = event.currentTarget.classList.contains("btn-selected");
      SessionConfigs.setPatchSelect(type, patch, state);
      HuntTimers.updateDisplayState(type);
      updateDisplayStatus(type);
    }
  }

  const toggleInstanceState = (type, instance, event) => {
    event.currentTarget.classList.toggle("btn-selected");
    const state = event.currentTarget.classList.contains("btn-selected");
    SessionConfigs.setInstanceSelect(type, instance, state);
    HuntTimers.updateDisplayState(type);

    updateDisplayStatus(type);
  }

  const toggleSRankCard = (event) => {
    event.currentTarget.classList.toggle("btn-selected");
    const state = event.currentTarget.classList.contains("btn-selected");

    const sRankCard = document.getElementById("SRankCard");
    const aRankCard = document.getElementById("ARankCard");
    
    sRankCard.classList.toggle("d-none");
    if (state) {
      if (aRankCard.classList.contains("d-none")) {
        sRankCard.classList.remove("col-xl-7");
        sRankCard.classList.add("col-xl-12");
      } else {
        sRankCard.classList.remove("col-xl-12");
        sRankCard.classList.add("col-xl-7");
        aRankCard.classList.remove("col-xl-12");
        aRankCard.classList.add("col-xl-5");
      }
    } else {
      aRankCard.classList.remove("col-xl-5");
      aRankCard.classList.add("col-xl-12");
    }
  }
  
  const toggleARankCard = (event) => {
    event.currentTarget.classList.toggle("btn-selected");
    const state = event.currentTarget.classList.contains("btn-selected");

    const sRankCard = document.getElementById("SRankCard");
    const aRankCard = document.getElementById("ARankCard");
    
    aRankCard.classList.toggle("d-none");
    if (state) {
      if (sRankCard.classList.contains("d-none")) {
        aRankCard.classList.remove("col-xl-5");
        aRankCard.classList.add("col-xl-12");
      } else {
        aRankCard.classList.remove("col-xl-12");
        aRankCard.classList.add("col-xl-5");
        sRankCard.classList.remove("col-xl-12");
        sRankCard.classList.add("col-xl-7");
      }
    } else {
      sRankCard.classList.remove("col-xl-7");
      sRankCard.classList.add("col-xl-12");
    }
  }
  
  const toggleHiddenHunts = (type, event) => {
    HuntTimers.setHideDeadHunts(type, event.currentTarget.checked);
    HuntTimers.updateDisplayState(type);
    SessionConfigs.setHideDeadHunts(type, event.currentTarget.checked);
    updateDisplayStatus(type);
  }

  React.useEffect(() => {
    const timerID = setInterval(() => {
      const huntCount = updateDisplayStatus("srank", true);
      if (document.getElementById("srankCounter")) document.getElementById("srankCounter").innerHTML = SessionConfigs.dictionaryLookup("header", "tableSpawnableHunt") + " " + huntCount.toString();
    }, 1000);

    return () => {
      clearInterval(timerID);
    };
  }, []);

  return (
    <>
      <div className="content" ref={hideDeadRef} >
        {alert}
        <audio src={notification} ref={audioRef}/>
        <Box style={{display: "flex", flexDirection: "row"}}>
          <Button fullWidth variant="outlined" className="btn-selected" onClick={(event) => toggleSRankCard(event)}>
            <LanguageDependentText header={"tableSRankCard"} variant="body2" fontSize={20} color={"#FFFFFF"}></LanguageDependentText>
          </Button>
          <Button fullWidth variant="outlined" className="btn-selected" onClick={(event) => toggleARankCard(event)}>
            <LanguageDependentText header={"tableARankCard"} variant="body2" fontSize={20} color={"#FFFFFF"}></LanguageDependentText>
          </Button>
        </Box>
        <Row style={{marginTop: 15}}>
          <ToastContainer
              style={{width: 400}}
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable
              pauseOnHover
            />
          <Col id={"SRankCard"} md={12} xl={7}>
            <Card>
              <CardBody>
                {loadingState ? null : ([
                  <Box key={"tableTitle"} pt={1} px={3}>
                    <Row>
                      <Col xs={12} sm={4}>
                        <LanguageDependentText header="srankTable" variant="h4" fontSize={24}/>
                      </Col>
                      <Col xs={6} sm={4}>
                        <Box display="flex" alignContent={"center"}>
                          <LanguageDependentText fontSize={20}>
                            <span id={"srankCounter"}></span>
                          </LanguageDependentText>
                        </Box>
                      </Col>
                      <Col xs={6} sm={4}>
                        <Box className="pull-right">
                          <CustomInput type="switch" id="srankHideDead" onClick={(event) => toggleHiddenHunts("srank", event)} label={<LanguageDependentText header={"tableHideDead"} component="p" fontSize={15}/>} />
                        </Box>
                      </Col>
                    </Row>
                  </Box>,
                  <Box key={"worldSelect"} pt={3} px={3}>
                    <LanguageDependentText header="worldSelectTitle" variant="h6"/>
                  </Box>,
                  <Box key={"worldGroup"} pt={1} px={3}>
                    {dcs.map((dc) => {
                      const worlds = SessionConfigs.getWorldsOfDataCenter(dc)["Names"];
                      return <Box key={dc+"dcGroup"} pt={1} px={3}>
                        <LanguageDependentText variant="h4" fontSize={24}>{dc}</LanguageDependentText>
                        {worlds.map((world)=>(
                          (timerConfigs.srankConfig.world[world]) ? (
                          <Button id={"srank"+world} key={world} variant="outlined" className="btn-selected" onClick={(event) => toggleWorldState("srank", world, event)}>
                            <LanguageDependentText text={world} variant="body2" fontSize={13}></LanguageDependentText>
                          </Button>
                          ) : (
                          <Button id={"srank"+world} key={world} variant="outlined" onClick={(event) => toggleWorldState("srank", world, event)}>
                            <LanguageDependentText text={world} variant="body2" fontSize={13}></LanguageDependentText>
                          </Button> 
                        )))}
                      </Box>
                    })}
                  </Box>,
                  <Box key={"patchSelect"} pt={1} px={3}>
                    <LanguageDependentText header="patchSelectTitle" variant="h6"/>
                  </Box>,
                  <Box key={"patchGroup"} pt={1} px={3} mb={4}>
                    {patches.map((patch)=>(
                      (timerConfigs.srankConfig.patch[patch]) ? (
                      <Button id={"srank"+patch} key={patch} variant="outlined" className="btn-selected" onClick={(event) => togglePatchState("srank", patch, event)}>
                        <LanguageDependentText patchName={patch} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button>
                      ) : (
                      <Button id={"srank"+patch} key={patch} variant="outlined" onClick={(event) => togglePatchState("srank", patch, event)}>
                        <LanguageDependentText patchName={patch} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button> 
                    )))}
                  </Box>,
                  <Box key={"tableContent"}>
                    <TableContainer sx={{ boxShadow: "none", overflowY: "hidden" }}>
                      <TimerTable name="SHuntTable" audioRef={audioRef} huntInfo={sHuntInfo}/>
                    </TableContainer>
                  </Box>
                ])}
              </CardBody>
            </Card>
          </Col>
          <Col id={"ARankCard"} md={12} xl={5}>
            <Card>
              <CardBody>
              {loadingState ? null : ([
                  <Box key={"tableTitle"} pt={1} px={3} style={{display: "flex", justifyContent: "space-between"}}>
                    <LanguageDependentText header="arankTable" variant="h4" fontSize={24}/>
                    <CustomInput type="switch" id="arankHideDead" onClick={(event) => toggleHiddenHunts("arank", event)} label={<LanguageDependentText header={"tableHideDead"} component="p" fontSize={15}/>} />
                  </Box>,
                  <Box key={"worldSelect"} pt={3} px={3}>
                    <LanguageDependentText header="worldSelectTitle" variant="h6"/>
                  </Box>,
                  <Box key={"worldGroup"} pt={1} px={3}>
                    {dcs.map((dc) => {
                      const worlds = SessionConfigs.getWorldsOfDataCenter(dc)["Names"];
                      return <Box key={dc+"dcGroup"} pt={1} px={3}>
                        <LanguageDependentText variant="h4" fontSize={24}>{dc}</LanguageDependentText>
                        {worlds.map((world)=>(
                          (timerConfigs.arankConfig.world[world]) ? (
                          <Button id={"arank"+world} key={world} variant="outlined" className="btn-selected" onClick={(event) => toggleWorldState("arank", world, event)}>
                            <LanguageDependentText text={world} variant="body2" fontSize={13}></LanguageDependentText>
                          </Button>
                          ) : (
                          <Button id={"arank"+world} key={world} variant="outlined" onClick={(event) => toggleWorldState("arank", world, event)}>
                            <LanguageDependentText text={world} variant="body2" fontSize={13}></LanguageDependentText>
                          </Button> 
                        )))}
                      </Box>
                    })}
                  </Box>,
                  <Box key={"patchSelect"} pt={1} px={3}>
                    <LanguageDependentText header="patchSelectTitle" variant="h6"/>
                  </Box>,
                  <Box key={"patchGroup"} pt={1} px={3}>
                    {patches.map((patch)=>(
                      (timerConfigs.arankConfig.patch[patch]) ? (
                      <Button id={"arank"+patch} key={patch} variant="outlined" className="btn-selected" onClick={(event) => togglePatchState("arank", patch, event)}>
                        <LanguageDependentText patchName={patch} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button>
                      ) : (
                      <Button id={"arank"+patch} key={patch} variant="outlined" onClick={(event) => togglePatchState("arank", patch, event)}>
                        <LanguageDependentText patchName={patch} variant="body2" fontSize={13}></LanguageDependentText>
                      </Button> 
                    )))}
                  </Box>,
                  <Box key={"instanceSelect"} pt={1} px={3}>
                    <LanguageDependentText header="instanceSelectTitle" variant="h6"/>
                  </Box>,
                  <Box key={"instanceGroup"} pt={1} px={3} mb={4}>
                    {["1","2","3"].map((instance)=>(
                      (timerConfigs.arankConfig.instance[instance]) ? (
                      <Button key={instance} variant="outlined" className="btn-selected" onClick={(event) => toggleInstanceState("arank", instance, event)}>
                        <LanguageDependentText header={"tableInstanceName"} variant="body2" fontSize={13}> {instance} </LanguageDependentText>
                      </Button>
                      ) : (
                      <Button key={instance} variant="outlined" onClick={(event) => toggleInstanceState("arank", instance, event)}>
                        <LanguageDependentText header={"tableInstanceName"} variant="body2" fontSize={13}> {instance} </LanguageDependentText>
                      </Button> 
                    )))}
                  </Box>,
                  <Box key={"tableContent"}>
                    <TableContainer sx={{ boxShadow: "none", overflowY: "hidden"}}>
                      <TimerTable name="AHuntTable" audioRef={audioRef} huntInfo={aHuntInfo}>
                        
                      </TimerTable>
                    </TableContainer>
                  </Box>
                ])}
              </CardBody>
            </Card>
            
          </Col>
        </Row>
      </div>
    </>
  );
};

const AllDataViewerCheck = ({match}) => {
  const history = useHistory();
  const [alert, setAlert] = React.useState(null);
  const audioRef = React.createRef();
  const [verified, setVerified] = React.useState(false);

  const [loadingState, setLoadingState] = React.useState(true);

  if (verified) {
    return <Timer match={match}/>
  } else {
    return <>
      <div className="content">
        {alert}
        <Row style={{marginTop: 15}}>
          <Col id={"VerificationText"} xs={12}>
            <Card>
              <CardBody>
                <LanguageDependentText variant="h5" fontSize={20}>
                  {"The Full DC Timer is a developmental pages that provide user with all Ranks timer from All DCs in your region (Global / CN are splitted). "}<br/><br/>
                  {"Using this page typically lead to significantly long load time, a large resources from the server side. The react component rendering will be quite slow as well."}<br/><br/>
                  {"I personally highly recommend not using it unless you are constantly jumping between DCs."}<br/><br/>
                  {"However, if you still prefer to see hunt data in this style, please proceed with loading and data will be retrieved after you manually approve the loading."}
                </LanguageDependentText>
                <Button fullWidth variant="outlined" className="btn-selected" onClick={() => setVerified(true)} style={{marginTop: 20}}>
                  <LanguageDependentText variant="body2" fontSize={24} color={"#FFFFFF"}>
                    {"Load Timers"}
                  </LanguageDependentText>
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  }
}

export default AllDataViewerCheck;
